import L from 'leaflet';
import type { DynmapMapDef } from './types';

/**
 * Dynmap HD projection — LiveAtlas class `Ta` / dynmap hdmap.js HDProjection.
 *
 * lat = -((tileSize - (wtp[3]x + wtp[4]y + wtp[5]z)) / 2^nativeZoom)
 * lng = (wtp[0]x + wtp[1]y + wtp[2]z) / 2^nativeZoom
 */
export function createHdProjection(mapDef: DynmapMapDef) {
  const wtp = mapDef.worldtomap.map(Number);
  const ptw = mapDef.maptoworld.map(Number);
  const tilescale = mapDef.tilescale || 0;
  const nativeZoomLevels = mapDef.mapzoomout;
  const tileSize = 128 << tilescale;
  const denom = 1 << nativeZoomLevels;

  return {
    locationToLatLng(x: number, y: number, z: number): L.LatLng {
      const mappedLat = wtp[3] * x + wtp[4] * y + wtp[5] * z;
      const mappedLng = wtp[0] * x + wtp[1] * y + wtp[2] * z;
      return L.latLng(-((tileSize - mappedLat) / denom), mappedLng / denom);
    },
    latLngToLocation(latlng: L.LatLng, y = 64): { x: number; y: number; z: number } {
      const lat = tileSize + latlng.lat * denom;
      const lng = latlng.lng * denom;
      const wx = ptw[0] * lng + ptw[1] * lat + ptw[2] * y;
      const wz = ptw[6] * lng + ptw[7] * lat + ptw[8] * y;
      return { x: wx, y, z: wz };
    },
    maxZoom: mapDef.mapzoomin + mapDef.mapzoomout,
    maxNativeZoom: mapDef.mapzoomout,
    mapzoomin: mapDef.mapzoomin,
    mapzoomout: mapDef.mapzoomout,
    tileSize,
    prefix: mapDef.prefix,
    imageFormat: mapDef['image-format'] || 'jpg',
  };
}

export type HdProjection = ReturnType<typeof createHdProjection>;

export function createDynmapCrs(): L.CRS {
  // Same as Dynmap / LiveAtlas
  return L.CRS.Simple;
}
